import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/barberare-stockholm-ahlens-city")({
  component: () => <Outlet />,
});
